import {
  actionCreators,
  IGlobalSearchInstanceState,
  selectError,
  selectIsSearching,
  selectResults,
} from '@app/components/GlobalSearch/modules/globalSearch'
import { ApplicationState } from '@app/store'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import AccessEditor from '../components/AccessEditor'

export default connect(
  createStructuredSelector<ApplicationState, IGlobalSearchInstanceState>({
    error: selectError(),
    isSearching: selectIsSearching(),
    results: selectResults('access-editor'),
  }),
  actionCreators,
)(AccessEditor)
